export const GET_USERS = "GET_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const ERROR_USER = "ERROR_USER";
export const LOADING = "LOADING";
export const CLEAR_USER_STATE = "CLEAR_USER_STATE";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
